import React from 'react';
import { Route } from 'react-router-dom';
import DirectAdmission from '@/pages/admission/DirectAdmission';
import StudentFeeSetting from '@/pages/admission/StudentFeeSetting';
import AdmissionFeeSetting from '@/pages/admission/AdmissionFeeSetting';
import AdmissionReport from '@/pages/admission/AdmissionReport';
import AdmissionReportList from '@/pages/admission/AdmissionReportList';
import BlockStudent from '@/pages/admission/BlockStudent';
import ICardReport from '@/pages/admission/ICardReport';
import ICardSetting from '@/pages/admission/ICardSetting';
import ICardTemplateManager from '@/pages/admission/ICardTemplateManager';
import ICardSettingsNew from '@/pages/admission/ICardSettingsNew';
import PrintICard from '@/pages/admission/PrintICardNew';
import PrintICardProfessional from '@/pages/admission/PrintICardProfessional';
import ICardBuilder from '@/pages/admission/ICardBuilder';
import OnlineAdmissionLink from '@/pages/admissions/OnlineAdmissionLink';
import BonafideCertificate from '@/pages/admission/BonafideCertificate';
import CourseCompletionCertificate from '@/pages/admission/CourseCompletionCertificate';
import StudentWithdrawal from '@/pages/admission/StudentWithdrawal';
import WithdrawalList from '@/pages/admission/WithdrawalList';
import AdmissionHub from '@/pages/admission/AdmissionHub';
import DocumentSettings from '@/pages/admission/DocumentSettings';
import StudentRegister from '@/pages/admission/StudentRegister';

export const admissionRoutes = (
  <React.Fragment>
    <Route path="admission/hub" element={<AdmissionHub />} />
    <Route path="admission/student-register" element={<StudentRegister />} />
    <Route path="admission/document-settings" element={<DocumentSettings />} />
    <Route path="admission/direct" element={<DirectAdmission />} />
    <Route path="admission/fee-setting" element={<StudentFeeSetting />} />
    <Route path="admission/admission-fee-setting" element={<AdmissionFeeSetting />} />
    <Route path="admission/reports" element={<AdmissionReportList />} />
    <Route path="admission/report/:studentId" element={<AdmissionReport />} />
    <Route path="admission/block-student" element={<BlockStudent />} />
    <Route path="admission/icard-report" element={<ICardReport />} />
    <Route path="admission/icard-setting" element={<ICardSetting />} />
    <Route path="admission/icard-settings" element={<ICardSettingsNew />} />
    <Route path="admission/icard-templates" element={<ICardTemplateManager />} />
    <Route path="admission/icard-builder" element={<ICardBuilder />} />
    <Route path="admission/print-icard" element={<PrintICard />} />
    <Route path="admission/print-icard-pro" element={<PrintICardProfessional />} />
    <Route path="admission/online-form-link" element={<OnlineAdmissionLink />} />
    <Route path="admission/bonafide-certificate" element={<BonafideCertificate />} />
    <Route path="admission/course-completion-certificate" element={<CourseCompletionCertificate />} />
    <Route path="admission/student-withdrawal" element={<StudentWithdrawal />} />
    <Route path="admission/withdrawal-list" element={<WithdrawalList />} />
  </React.Fragment>
);
